/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { z } from 'zod';
import type { TFunction } from 'i18next';

/**
 * Builds the zod schema for the create-sale form with localized validation
 * messages. Mirrors what `Sale.validate()` checks on the backend — property,
 * buyer and a positive value — so the form fails the same facts the
 * backend would, before the round trip.
 */
export function buildSaleFormSchema(t: TFunction) {
  return z.object({
    propertyId: z.string().min(1, { message: t('create.errors.propertyRequired') }),
    buyerId: z.string().min(1, { message: t('create.errors.buyerRequired') }),
    acceptedValue: z.number({
      required_error: t('create.errors.valueRequired'),
      invalid_type_error: t('create.errors.valueRequired'),
    }).positive({ message: t('create.errors.valuePositive') }),
    commissionPercentage: z.number().min(0).max(100).optional(),
    responsibleBrokerEmail: z.string().optional(),
  });
}

export type SaleFormData = z.infer<ReturnType<typeof buildSaleFormSchema>>;
